import { setDefaultOptions } from 'date-fns';
import { locale } from './locale.ts';

setDefaultOptions({ locale });

export { TZDate } from '@date-fns/tz';
export type { Duration } from 'date-fns';
// re-export date-fns functions
export {
  add,
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  endOfDay,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  getHours,
  getISOWeek,
  getISOWeekYear,
  isAfter,
  isBefore,
  isFuture,
  isSameDay,
  isWeekend,
  isWithinInterval,
  max,
  min,
  set,
  startOfDay,
  startOfHour,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
  sub,
} from 'date-fns';
export { each, eachDay } from './each.ts';
export { format, format as formatDate, formatYMD, localDay, utcDay } from './format.ts';
export { getHolidays, type Holiday } from './holidays.ts';
export { getInvoiceIssueDateWarning, invoiceMinMaxIssueDate, isValidInvoiceIssueDate } from './invoice.ts';
export { mvaPeriod } from './mvaPeriod.ts';
export { isDate, isValidDate, parseDate, toDate } from './parseDate.ts';
export { getMonthRange, getMonthsRange, getWeekRange, rangePresets } from './range.ts';
export type { DateInput, DateRange } from './types.ts';
export type { IsSameCompareType } from './utils.ts';
export { isBetween, isSame, isSameOrAfter, isSameOrBefore } from './utils.ts';
